import React from "react";

import "./styles.scss";

import {Container, Row, Col} from "reactstrap";
import IconPlus from "../../components/Icons/IconPlus";

const Thanks = () => (
    <Container fluid tag="main" className="thanks">
        <Row tag="section" className="d-flex justify-content-center align-items-center h-100">
            <Col className="text-center">
                <h1 className="title">¡Gracias por tu interés!</h1>
                <h3 className="title">En breve nos pondremos en contacto contigo</h3>
                <a href="/" className="btn__cta mt-5">
                    <IconPlus width={66} height={66} />
                    <span>Volver a la home</span>
                </a>
            </Col>
        </Row>
    </Container>
);

export default Thanks;